import { t, Trans } from "@lingui/macro";
import { Check, Lightning, Sparkle } from "@phosphor-icons/react";
import { Badge } from "@reactive-resume/ui";

const features = [
  { label: () => t`Improve writing clarity and impact` },
  { label: () => t`Fix spelling and grammar` },
  { label: () => t`Change tone: professional, casual, confident & more` },
  { label: () => t`Expand content with more detail` },
  { label: () => t`Quantify achievements with metrics` },
  { label: () => t`Generate content for empty sections` },
  { label: () => t`AI Resume Coach with scoring & feedback` },
  { label: () => t`Chat assistant for resume advice` },
];

export const OpenAISettings = () => {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-x-2">
          <h3 className="text-2xl font-bold leading-relaxed tracking-tight">{t`AI Assistant`}</h3>
          <Badge variant="primary" className="gap-1">
            <Sparkle size={10} weight="fill" />
            {t`Enabled`}
          </Badge>
        </div>
        <p className="leading-relaxed opacity-75">
          {t`AI-powered tools are built into CareerBldr to help you create a standout resume. No setup needed. Everything works out of the box.`}
        </p>
      </div>

      <div className="rounded-xl border border-primary/10 bg-gradient-to-br from-primary/[0.03] via-primary/[0.06] to-primary/[0.02] p-5">
        <div className="flex items-center gap-2.5">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
            <Lightning size={20} weight="fill" className="text-primary" />
          </div>
          <div>
            <p className="text-sm font-semibold">{t`What AI can do for you`}</p>
            <p className="text-xs text-muted-foreground">
              {t`Available in every section of the resume builder`}
            </p>
          </div>
        </div>

        <div className="mt-4 grid gap-2 sm:grid-cols-2">
          {features.map((feature, i) => (
            <div key={i} className="flex items-start gap-2 rounded-lg py-1">
              <Check size={14} weight="bold" className="mt-0.5 shrink-0 text-primary" />
              <span className="text-xs leading-relaxed text-foreground/80">{feature.label()}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="prose prose-sm prose-zinc max-w-full dark:prose-invert">
        <p>
          <Trans>
            AI features are powered by our server-side integration. Your resume content is processed
            securely and is never stored or used for training. The AI assistant is available directly
            in the builder. Look for the <Sparkle size={12} weight="fill" className="inline text-primary" /> icon
            in the bottom toolbar.
          </Trans>
        </p>
      </div>
    </div>
  );
};
